module.exports = __webpack_public_path__ + "img/bee__1.02c34218.svg";